import Vue from 'vue';
import VueRouter from 'vue-router';

import UserPortal from '../components/UserPortal';
import ForgotPassword from '../components/ForgotPassword';
import Login from '../components/Login';
import SignUp from '../components/SignUp';
import ResetPassword from '../components/ResetPassword';

import { isLoggedIn } from '../utils/auth';

Vue.use(VueRouter);

const requireAuth = (to, from, next) => {
  if (isLoggedIn()) {
    next();
  } else {
    next(`/login?redirect=${encodeURIComponent(from.path)}`);
  }
};

const requireNoAuth = (to, from, next) => {
  if (!isLoggedIn()) {
    next();
  } else {
    next('/');
  }
};

const routes = [
  { path: '/', name: 'home', component: UserPortal, beforeEnter: requireAuth },
  { path: '/forgot/:email?', component: ForgotPassword, beforeEnter: requireNoAuth },
  { path: '/login/:email?', component: Login, beforeEnter: requireNoAuth },
  { path: '/signup/:email?', component: SignUp, beforeEnter: requireNoAuth },
  { path: '/resetPassword', component: ResetPassword, beforeEnter: requireNoAuth }
];

const router = new VueRouter({
  routes,
  base: '/user'
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js